import { AuthenticatedLayout } from "../../../layouts";
import { FC } from "react";
import { PaydayAdvanceReport } from "../../../components/Reports/Employee/PaydayAdvanceReport";

export interface IPaydayAdvanceReportPage { }

export const PaydayAdvanceReportPage: FC<IPaydayAdvanceReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Payday Advance Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<PaydayAdvanceReport />}
		/>
	);
};
